import React from "react";
import Iridescence from "./Iridescence";
import "./Hero.css";
import devlabLogo from '../images/logo.png';
export default function Hero() {
  return (
    <section className="hero" id="home">
      <div className="hero-bg">
        <Iridescence
          color={[0.5, 0.6, 0.8]}
          mouseReact={true}
          amplitude={0.1}
          speed={1}
        />
      </div>
      <div className="hero-content">
      <div className="hero-title">
       <div className="hero-logo">
         <img src={devlabLogo} alt="logo"/>
       </div>
        Private Web Services
        </div> 
        <div className="hero-desc">
            Tailored to your needs
        </div>
      </div>

    </section>
  );
}